export const APP_ID = 'linexo-site-connect'

export const MODAL_CONTAINER_ID = 'linexo-site-connect-modal-container'
export const FLYOUT_CONTAINER_ID = 'linexo-site-connect-flyout-container'

export const DEFAULT_LOCALE = 'de-DE'
